// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3jc3g","col":"styles_col__F7PKj","fulfillmentStatus":"styles_fulfillmentStatus__1FVln","emailCol":"styles_emailCol__12-MB"};